const errors = {
  ERROR_1: "Erreur de test",
  ERROR_SERVER: "Erreur de traitement de la donnée",
  ERROR_SERVER_UPDATE_PASSWORD: "Erreur lors de la mise à jour du mot de passe",
  ERROR_VERIFY_USER: "Erreur dans la vérification de l'utilisateur",
};

export default errors;
